import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const {FiClock, FiSettings, FiHeart, FiBookOpen} = FiIcons;

const Problems = () => {
  const problems = [
    {
      icon: FiClock,
      title: 'การเลือกฤกษ์ยาม',
      description: 'ตามหลักโหราศาสตร์จีน การเลือกวันเวลาที่เหมาะสมมีผลต่อการเชื่อมโยงพลังงาน',
      color: 'from-red-500 to-red-600'
    },
    {
      icon: FiSettings,
      title: 'ขั้นตอนพิธีกรรม',
      description: 'พิธีกรรมแต่ละขั้นตอนมีความหมายและวิธีการเฉพาะตามตำราโบราณ',
      color: 'from-amber-500 to-amber-600'
    },
    {
      icon: FiHeart,
      title: 'การเตรียมกายและใจ',
      description: 'สภาวะร่างกายและจิตใจมีผลต่อการรับพลังตามความเชื่อ',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: FiBookOpen,
      title: 'ความเข้าใจในหลักการ',
      description: 'การขาดความรู้ความเข้าใจทำให้ปฏิบัติไม่ครบถ้วน',
      color: 'from-green-500 to-green-600'
    }
  ];

  return (
    <section className="py-10 md:py-16 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
          className="text-center mb-8"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            เหตุใดการไหว้พระบางครั้งจึงไม่เป็นไปตามที่หวัง
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            จากประสบการณ์ด้านโหราศาสตร์กว่า 18 ปี พบว่าคนส่วนใหญ่มักพลาดในเรื่องนี้เวลาขอพร
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {problems.map((problem, index) => (
            <motion.div
              key={index}
              initial={{opacity: 0, y: 50}}
              whileInView={{opacity: 1, y: 0}}
              transition={{duration: 0.6, delay: index * 0.1}}
              viewport={{once: true}}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${problem.color} rounded-lg flex items-center justify-center mb-4`}>
                <SafeIcon icon={problem.icon} className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {problem.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {problem.description}
              </p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.8, delay: 0.4}}
          viewport={{once: true}}
          className="mt-8 text-center"
        >
          <div className="bg-gradient-to-r from-red-50 to-amber-50 border border-red-200 rounded-xl p-8 max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 font-medium">
              ปัจจัยเหล่านี้ล้วนมีความสำคัญต่อการทำพิธีกรรมให้เกิดประสิทธิภาพสูงสุด
              <br />
              <span className="text-red-700 font-semibold">
                การขาดความรู้ในด้านใดด้านหนึ่งอาจส่งผลต่อผลลัพธ์ที่ได้รับ
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Problems;